import React from 'react';
import {
  InfoSec,
  Container,
  Title,
  Heading,
  InfoRow,
  InfoColumn,
  TextWrapper,
  Subtitle,
  StatGrid,
  StatCard,
  ImgWrapper,
  ImgRing,
  Img,
  Blob,
} from './About.elements';

const myPhoto = `${process.env.PUBLIC_URL}/about_enes.JPG`;

const reveal = {
  hidden: { opacity: 0, y: 28 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, delay: 0.08 * i, ease: 'easeOut' },
  }),
};

function About({ topLine, headline, description, highlights = [], imgStart, start }) {
  return (
    <InfoSec id="about">
      <Container>
        <Title variants={reveal} initial="hidden" animate="visible">
          {topLine || 'About me'}
        </Title>
        <Heading variants={reveal} custom={1} initial="hidden" animate="visible">
          {headline}
        </Heading>

        <InfoRow imgStart={imgStart}>
          <InfoColumn>
            <TextWrapper>
              <Subtitle variants={reveal} custom={2} initial="hidden" animate="visible">
                {description}
              </Subtitle>

              <StatGrid>
                {highlights.map((h, i) => (
                  <StatCard
                    key={h.label}
                    variants={reveal}
                    custom={3 + i}
                    initial="hidden"
                    animate="visible"
                  >
                    <strong>{h.value}</strong>
                    <span>{h.label}</span>
                  </StatCard>
                ))}
              </StatGrid>
            </TextWrapper>
          </InfoColumn>

          <InfoColumn>
            <ImgWrapper
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, ease: 'easeOut' }}
              start={start}
            >
              <Blob />
              <ImgRing>
                <Img src={myPhoto} alt="Enes Güngör" />
              </ImgRing>
            </ImgWrapper>
          </InfoColumn>
        </InfoRow>
      </Container>
    </InfoSec>
  );
}

export default About;
